
















import Vue from "vue";
import { state } from "../data/csv/state.csv";
import { CognniCsvReport } from "../data/csv/model";
import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import { UseModal } from "@/components/root/modal";
import CsvTableRow from "./CsvTableRow.vue";
import { get_menu } from "./menu";
import * as report_api from "../data/csv/api";
import { table_config } from "./table.config";
import { NotificationsManager } from "@/components/root/navbar/notifications/NotificationManager";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { onMounted, onBeforeUnmount } from "@vue/composition-api";
import {
  reportDetailsHtml,
  trackReportEvent,
} from "../data/report-analytics";
export default Vue.extend({
  components: {
    VirtualTable,
  },
  setup() {
    const show_template = (report_id: string) => {
      console.log(report_id);
    };

    const show_menu = async (payload: {
      event: MouseEvent;
      item: CognniCsvReport;
    }) => {
      const { event, item } = payload;
      const { status } = item;
      const menu_res = await UseDrillDownMenu().show({
        event: event,
        menu: get_menu(status),
      });
      if (menu_res.didUserSelectedAnAction) {
        switch (menu_res.actionSelected) {
          case "download": {
            const download_res = await report_api.download_csv_report({
              report_name: item.name,
              report_id: item.id,
            });
            if (download_res.success) {
              trackReportEvent("downloaded", {
                report_id: item.id,
                report_name: item.name,
                report_type: "csv",
                report_subtype: item.type,
                entity_type: item.entity_type,
                status: item.status,
                parameters: item.params,
                source: "csv_reports_table",
              });
            }
            NotificationsManager.remove(item.id);
            break;
          }
          case "inspect_details":
            trackReportEvent("details_inspected", {
              report_id: item.id,
              report_name: item.name,
              report_type: "csv",
              report_subtype: item.type,
              entity_type: item.entity_type,
              status: item.status,
              parameters: item.params,
              source: "csv_reports_table",
            });
            UseModal().showSimple({
              title: "Report Details",
              desc: reportDetailsHtml({
                report_id: item.id,
                report_name: item.name,
                report_type: "csv",
                report_subtype: item.type,
                entity_type: item.entity_type,
                status: item.status,
                parameters: item.params,
              }),
              submitBtnText: "Close",
              cancelBtnText: "",
            });
            break;
          case "delete":
            state.delete_report(item.id);
            break;
          default:
            break;
        }
      }
    };

    const subs = {
      show_menu: emptyFn(),
    };
    onMounted(() => {
      subs.show_menu = EventBus.listen("ShowCsvReportMenu", show_menu);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      table_config,
      items: state.items,
      load_more: state.load_more_items,
      no_results: state.has_no_results,
      is_show_reports_loader: state.is_loading,
      show_template,
      show_menu,
      CsvTableRow,
    };
  },
});
